export const scrollWithOffset = (element: Element, yOffset = -70) => {
  const yCoordinate = element.getBoundingClientRect().top + window.pageYOffset;
  window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
};
